import isEmpty from 'lodash/isEmpty';

import api from 'auth/resources/forgot-password.api';

import successModalTpl from './views/success-confirm-modal.html';
import forgotPassTpl from './forgot-password.html';

// eslint-disable-next-line no-undef
@Inject('$state', 'gettextCatalog', 'Notifications')
class ForgotPasswdController {
  $onInit() {
    this.securityQuestions = null;
    this.securityAnswers = null;
  }

  redirect() {
    this.$state.go('home-view');
  }

  async applyEmail(passwordResetForm) {
    passwordResetForm.$setSubmitted();

    if (passwordResetForm.$invalid) return;

    const securityQuestions = await api.fetchSecurityQuestionsByUserName(this.email, this.captchaToken);

    if (isEmpty(securityQuestions)) {
      await this.Notifications.showAlert(
        this.gettextCatalog.getString('Unable to Reset Password'),
        this.gettextCatalog.getString('Sorry, you cannot reset your password because your registration has not been completed. Please follow instructions sent in authentication email to finish registration.'),
      ).result;

      this.redirect();
    } else {
      this.securityQuestions = securityQuestions;
    }
  }

  cancelResetPasswd() {
    this.redirect();
  }

  onQuestionChange(form) {
    form.$setPristine();
    form.$setUntouched();
    this.securityAnswer = '';
    this.attemptsLeft = null;
  }


  async forgotPassword(passwordResetForm) {
    try {
      this.attemptsLeft = null;
      const data = {
        username: this.email,
        challenges: [
          {
            questionId: this.securityQuestion,
            answer: this.securityAnswer,
          },
        ],
      };


      passwordResetForm.$setSubmitted();

      if (passwordResetForm.$invalid) return;

      await api.resetPassword(data);

      await this.Notifications.showComplexDialog({
        template: successModalTpl,
      }).result;

      this.redirect();
    } catch ({ data = {} }) {
      const { errors } = data;
      const [error] = errors;

      this.attemptsLeft = error.params.ATTEMPTS_LEFT;
    }
  }
}

export default class ForgotPasswordComponent {
  constructor() {
    this.template = forgotPassTpl;
    this.controller = ForgotPasswdController;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/components/forgot-password/forgot-password-component.js